export default __webpack_public_path__ + "static/media/Schwein-vor-Hütte.76b4fc72.webp";